<template>
  <div class="container">
    <BreadcrumbGroup v-if="!isAuWallet()" :items="breadcrumbItems" />

    <HeadingOne class="-margin-md"
      >au PAY 残高にチャージ（お借り入れ）</HeadingOne
    >

    <WizardGroup class="-margin-md">
      <MainWizard :active-index="2" type="mb"></MainWizard>
    </WizardGroup>

    <NoticeBox class="-success -margin-md">
      <NoticeHeader>
        <h3 class="heading">お借り入れのお申し込みが完了いたしました。</h3>
      </NoticeHeader>
      <NoticeBody>ご利用ありがとうございました。</NoticeBody>
      <NoticeBody v-if="!isAuWallet()"
        >お取引の内容は<BtnText router-name="mb004" class="-underline"
          >「お取引履歴のご確認」</BtnText
        >よりご確認いただけます。</NoticeBody
      >
    </NoticeBox>

    <TableBox class="_mb-md-60 _mb-sm-25">
      <TableBody>
        <TableRow>
          <TableHeader> チャージ予定日 </TableHeader>
          <TableData class="-pctextright">
            お手続き完了後、すぐにご利用いただけます。
          </TableData>
        </TableRow>
        <TableRow>
          <TableHeader> お借り入れ金額 </TableHeader>
          <TableData class="-pctextright">
            {{ numberToCurrency(userData.amount * 10000) }}
          </TableData>
        </TableRow>
      </TableBody>
    </TableBox>

    <template v-if="!isAuWallet()">
      <BtngroupSingle class="_mb-md-120 _mb-sm-40">
        <BtnMain class="-normal" router-name="mb001">
          会員さま専用サイトトップへ
        </BtnMain>
      </BtngroupSingle>
    </template>
    <template v-else>
      <p class="_mb-md-120 _mb-sm-40">
        ※画面右上の閉じるボタンを押していただき、<br />au PAY
        アプリに戻ることが出来ます。
      </p>
    </template>
  </div>
  <!-- container -->
</template>

<script>
import { getUserDataLambdaInvoke } from "@/utils/LambdaHelper";
import { isAuWallet } from "@/utils/UserAgent";
import { numberToCurrency } from "@/utils/Filter";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage } from "@/utils/Other";

import HeadingOne from "@/components/heading/HeadingOne";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import NoticeBody from "@/components/box/NoticeBody";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import BtnText from "@/components/button/BtnText";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";

export default {
  name: "Tem008",
  components: {
    BtnText,
    BtnMain,
    BtngroupSingle,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    NoticeBody,
    NoticeHeader,
    NoticeBox,
    MainWizard,
    WizardGroup,
    HeadingOne,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "au PAY 残高にチャージ（お借り入れ）｜お借り入れ",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト",
    });

    return {
      numberToCurrency,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "au PAY 残高にチャージ（お借り入れ）",
          active: true,
        },
      ],
      userData: {
        amount: "",
      },
    };
  },
  mounted() {
    try {
      getUserDataLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key];
            }
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {
    isAuWallet: function () {
      return isAuWallet();
    },
  },
};
</script>

<style scoped></style>
